"use strict";
function baseProperty(key) {
    return function (object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;
//# sourceMappingURL=_baseProperty.js.map